<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Camera",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Camera",
      items: [
        {
          text: "Home",
        },
         {
          text: "Settings",
        },
        {
          text: "Camera",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>